import {Home} from '@/layout'

export default {
    path: '/manager',
    component: Home,
    meta: {
        roles: ['manager'],
        childrenRoles: false
    },
    children: [
        {
            path: '',
            meta: {
                title: '品牌管理'
            },
            component: () => import('@/page/manager'),
            children: [
                {
                    path: '',
                    meta: {
                        title: '品牌信息'
                    },
                    component: () => import('@/page/manager/OrgInfo'),
                },
                {
                    path: 'banner',
                    meta: {
                        title: 'Banner设置'
                    },
                    component: () => import('@/page/backstage/banner'),
                },
                {
                    path: 'course',
                    meta: {
                        title: '课程编排'
                    },
                    component: () => import('@/page/manager/course'),
                },
                {
                    path: 'school',
                    meta: {
                        title: '校区管理'
                    },
                    component: () => import('@/page/manager/schools'),
                },
            ]
        }
    ]
}
